import { split } from 'lodash';
import isNil from 'lodash/isNil';
import keys from 'lodash/keys';

import {
  initiativeDataJson,
  initiativeNumericIdsDic,
  initiativesDicKeys,
} from '@modules/shared/constants';

export const getIniativeJson = (activityData: {
  initiative: string[];
  initiativeData: { [key: string]: { [key: string]: string } };
}) => {
  const iniArray = activityData?.initiative ?? [];
  const mappedIniativeData = iniArray.reduce((curr, iniKey) => {
    const initiativeData = activityData.initiativeData?.[iniKey];
    if (!isNil(initiativeData)) {
      const flatData = keys(initiativeData).reduce(
        (dataCurr, dataKey) => ({
          ...dataCurr,
          [`${iniKey}_${dataKey}`]: Number(initiativeData[dataKey]),
        }),
        {},
      );

      return { ...curr, [iniKey]: true, ...flatData };
    }

    return { ...curr, [iniKey]: true };
  }, {} as { [key: string]: number | boolean });

  const completeIniativeData = keys(initiativeDataJson).reduce(
    (curr, key) => ({
      ...curr,
      [key]: mappedIniativeData[key] ?? initiativeDataJson[key],
    }),
    {},
  );

  return JSON.stringify(completeIniativeData);
};

export const parseLegacyInitiatives = (benefitGroup: string) => {
  const splitBenefitGroup = split(benefitGroup, ';Initiative: ');
  const legacyInitiatives = split(splitBenefitGroup[1], ';');
  return legacyInitiatives.map(el => initiativeNumericIdsDic[el]);
};

export const parseInitiative = (benefitGroup: string) => {
  if (isNil(benefitGroup) || benefitGroup === '') {
    return { initiative: [], initiativeData: {} };
  }
  const parsedInitiative = JSON.parse(benefitGroup);
  const iniFieldValues = keys(parsedInitiative).reduce(
    (curr, key) => {
      if (initiativesDicKeys.includes(key)) {
        return {
          ...curr,
          initiative: parsedInitiative[key]
            ? [...(curr?.initiative ?? []), key]
            : curr?.initiative ?? [],
        };
      }
      const splitKey = key.split('_', 2);
      return {
        ...curr,
        initiativeData: {
          ...curr.initiativeData,
          [splitKey[0]]: {
            ...(curr.initiativeData[splitKey[0]] ?? {}),
            [splitKey[1]]: `${parsedInitiative[key]}`,
          },
        },
      };
    },
    { initiative: [], initiativeData: {} as { [key: string]: object } },
  );
  return iniFieldValues;
};
